<div class="waitlistItem-card base-color w-100">

    <div class="card-header" fxLayoutAlign="center center">
        <span class="scheduler-color-circle" [style.background-color]="waitlistItem.Color"></span>
        <span class="pr-2 pl-2" fxFlex>
            <span *ngIf="waitlistItem.SchedulerName">{{waitlistItem.SchedulerName}}&nbsp;</span>
            <span *ngIf="waitlistItem.BranchName">({{waitlistItem.BranchName}})</span>
        </span>
        <app-waitlist-item-menu [waitlistItem]="waitlistItem"
        (createAppt)="onCreateAppointment($event)"
        (edit)="onEdit($event)"
        (delete)="onDelete($event)"></app-waitlist-item-menu>
    </div>
    
    <span class="seperator"></span>
    <div class="card-content" fxLayout="row">
        <div fxFlex="0 0 20px">&nbsp;</div> 
        <!-- must set overflow:hidden here -->
         <div fxFlex="1 1 auto" fxLayout="column" style="overflow: hidden;">
            <div class="clientName mt-1" title="{{waitlistItem.SchedulerWaitListID}}">{{waitlistItem.CustomerName}}
                <span *ngIf="waitlistItem.Customer.Gender != null"> 
                    ({{ waitlistItem.Customer.Gender == 1 ? ('GENDER.M' | translate) :
                    ('GENDER.F' | translate)}}) 
                  </span>
                  <span class="patPhone">{{waitlistItem.MobilePhone}}</span>
            </div>
            <div>
                <span>{{ waitlistItem.FromDate}} - {{waitlistItem.ToDate}}</span>
                <span style="margin:0 8px;">|</span>
                <span>{{ waitlistItem.FromTime}} - {{waitlistItem.ToTime}}</span><br>
                <!-- <span style="margin:0 8px;">|</span> -->
                <span>{{waitlistItem.WeekDays}}</span>
            </div>
            <div>
                <div fxLayout="row">

                    <div class="column nowrap">
                        <span>{{ 'COMMON.DUR' | translate }}: {{waitlistItem.Duration}} {{ 'TIME.MINS' | translate }}</span>
                        <span style="margin:0 11px;">|</span>
                        <span>{{ 'COMMON.PRIORITY' | translate }}: {{waitlistItem.Priority}}</span>
                    </div>

                    <div class="px-1" fxLayout="row" fxLayoutAlign="space-between none" style="line-height:28px;flex:auto;">
                      <div class="column icon_container">
                          <span *ngIf="waitlistItem.Note" class="ic-status ic-status-remark"></span>
                      </div>
                      <div class="column icon_container">
                          <span *ngIf="waitlistItem.Status == STATUS_VACANT" class="ic-status ic-status-vacant"></span>
                      </div>
                    </div>
                    
                </div>
            </div>
        </div>
    </div>
</div>